var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.67,288.6s.66,12.64,1.33,15.95,3.34,15.13,4.35,25.57a85.42,85.42,0,0,0,3,16s8.09,31.42,8.57-8.05c.17-13.92-1.33-35.8-1.33-35.8l.66-6.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.83,294.83s-6.8,1.43-9.13,6.74-2.65,17.57-2.32,20.88a57.81,57.81,0,0,1,0,8l9.3-3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.05,312.18s-21.92,12.26-22.92,14.25-21.58,64-21.91,68.29,16.27,20.55,16.27,20.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.68,234.94s-9.63,5.63-10.29,13.92a51.24,51.24,0,0,0,1.66,16.24s-3-2.65-3.32,3.32,4.65,10.6,6.64,10.6h2s4.43,9.1,9.75,13.41,10.51,4.5,14.16,3.17,10.63-7.29,11.3-15.25,0-21.22-.67-29.5-2.32-14.26-11.29-17.24S225.33,232.61,220.68,234.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.48,91.69s-24.21-44.8-76.09-47.41-70.34,50.51-108.14,71c-19.79,10.74-59.81-7.24-80.92-1.09C84.84,133.88,60.75,224,89.79,271.59c25.13,41.26,68.48,60.19,134,59.93s111.54,2,169.46-45.34S445.84,150.88,417.48,91.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.48,91.69s-24.21-44.8-76.09-47.41-70.34,50.51-108.14,71c-19.79,10.74-59.81-7.24-80.92-1.09C84.84,133.88,60.75,224,89.79,271.59c25.13,41.26,68.48,60.19,134,59.93s111.54,2,169.46-45.34S445.84,150.88,417.48,91.69Z",
    style: {
      fill: "#fff",
      opacity: 0.800000011920929,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-4--inject-34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 99.49,
    width: 28.31,
    height: 6.52,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 108.91,
    width: 18.6,
    height: 6.52,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 118.33,
    width: 10.71,
    height: 6.52,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 99.49,
    width: 28.31,
    height: 6.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 108.91,
    width: 18.6,
    height: 6.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 118.33,
    width: 10.71,
    height: 6.52
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 200.67,
    y: 176.7,
    width: 19.63,
    height: 9.6,
    transform: "translate(28.99 391.99) rotate(-90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 180.07,
    width: 12.89,
    height: 9.6,
    transform: "translate(39.49 409.23) rotate(-90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.52,
    y: 182.8,
    width: 7.42,
    height: 9.6,
    transform: "translate(50.62 425.83) rotate(-90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.67,
    y: 176.7,
    width: 19.63,
    height: 9.6,
    transform: "translate(28.99 391.99) rotate(-90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 180.07,
    width: 12.89,
    height: 9.6,
    transform: "translate(39.49 409.23) rotate(-90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 234.52,
    y: 182.8,
    width: 7.42,
    height: 9.6,
    transform: "translate(50.62 425.83) rotate(-90)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,205.64H319.79a11.58,11.58,0,0,0,11.6-11.58V98.26a11.58,11.58,0,0,0-11.6-11.58H203.54a11.59,11.59,0,0,0-11.6,11.58v95.8A11.59,11.59,0,0,0,203.54,205.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 172.75,
    x2: 318.29,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 177.18,
    x2: 318.29,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 181.61,
    x2: 318.29,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 186.05,
    x2: 318.29,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 190.48,
    x2: 318.29,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 100.46,
    x2: 245.87,
    y2: 100.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 104.89,
    x2: 245.87,
    y2: 104.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 109.32,
    x2: 245.87,
    y2: 109.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 113.75,
    x2: 245.87,
    y2: 113.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 118.19,
    x2: 245.87,
    y2: 118.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,135.3l7.9,4.15-.89-22.28-18.88,11.91,7.9,4.14-5.94,11.31h0a4.76,4.76,0,0,0-2.9,1l-10.46-4.86s0,0,0,0a4.82,4.82,0,0,0-9.64,0,4.75,4.75,0,0,0,.44,2l-13.71,14.86a4.6,4.6,0,0,0-1.35-.22,5.2,5.2,0,0,0-.69.07l-19.71-24.91a4.75,4.75,0,0,0,.42-2,4.82,4.82,0,0,0-9.64,0,5,5,0,0,0,.25,1.46l-22.51,22.92a4.93,4.93,0,0,0-1.65-.3,4.81,4.81,0,1,0,4.82,4.81,4.6,4.6,0,0,0-.16-1.18L239.4,135a4.79,4.79,0,0,0,1.37.22,5,5,0,0,0,.88-.08L261.26,160a4.82,4.82,0,1,0,8.88.62l14.06-15.23a5.29,5.29,0,0,0,.81.08,4.77,4.77,0,0,0,2.68-.82l10.7,5a4.81,4.81,0,1,0,8.76-3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165.37 157.19 151.85 136.06 129.51 152.49 108.91 111.72 54.55 146.28 54.55 174.2 177.13 174.2 177.13 150.73 165.37 157.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8766012586124072px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8766012586124072px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,101.38h-9.87a2.67,2.67,0,0,0-1.21,5.06l-3.45,3.67,6.29-3.37h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,101.38h-9.87a2.67,2.67,0,0,0-1.21,5.06l-3.45,3.67,6.29-3.37h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,125.24h-9.87a2.67,2.67,0,0,0-1.21,5.06L152.9,134l6.29-3.38h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,125.24h-9.87a2.67,2.67,0,0,0-1.21,5.06L152.9,134l6.29-3.38h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,205.64H175.75a11.58,11.58,0,0,0,11.6-11.58V98.26a11.58,11.58,0,0,0-11.6-11.58H59.5A11.58,11.58,0,0,0,47.9,98.26v95.8A11.58,11.58,0,0,0,59.5,205.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 99.61,
    x2: 64.74,
    y2: 99.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 108.33,
    x2: 64.74,
    y2: 108.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 117.05,
    x2: 64.74,
    y2: 117.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 125.77,
    x2: 64.74,
    y2: 125.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 134.49,
    x2: 64.74,
    y2: 134.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.18,26.18,0,0,0-19.05,8.11l5.59,5.35a18.62,18.62,0,1,1,13.46,31.48v7.73a26.34,26.34,0,1,0,0-52.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.65,113.5l-3,7.12a18.61,18.61,0,0,1-7.26,35.75v7.73a26.33,26.33,0,0,0,10.27-50.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.32,86.68H350.62a14.41,14.41,0,0,0-14.42,14.4v90.17a14.41,14.41,0,0,0,14.42,14.39h108.7a14.4,14.4,0,0,0,14.42-14.39V101.08A14.41,14.41,0,0,0,459.32,86.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 172.75,
    x2: 389.32,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 177.18,
    x2: 389.32,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 181.61,
    x2: 389.32,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 186.05,
    x2: 389.32,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 190.48,
    x2: 389.32,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 172.75,
    x2: 457.77,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 177.18,
    x2: 457.77,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 181.61,
    x2: 457.77,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 186.05,
    x2: 457.77,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 190.48,
    x2: 457.77,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.86,
    y1: 98.89,
    x2: 424.3,
    y2: 98.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.86,
    y1: 103.33,
    x2: 424.3,
    y2: 103.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.76,372.34H458.44a15.29,15.29,0,0,0,15.3-15.27V227.86a15.29,15.29,0,0,0-15.3-15.28H277.24a15.29,15.29,0,0,0-15.3,15.28V313",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 330.33,
    width: 29.18,
    height: 17.42,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 313.67,
    width: 29.18,
    height: 34.08,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 313.67,
    width: 29.18,
    height: 34.08,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 280.35,
    width: 29.18,
    height: 67.4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 225.94,
    x2: 334.54,
    y2: 225.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 230.37,
    x2: 334.54,
    y2: 230.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 234.81,
    x2: 334.54,
    y2: 234.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 239.24,
    x2: 334.54,
    y2: 239.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 243.67,
    x2: 334.54,
    y2: 243.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })));
};
export { SvgAnalytics as ReactComponent };
export default "/6c19baf37f6774e792f636e0e470bac4.svg";